// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"453":"4a8c7621","488":"186f850c","746":"79737fc0"}[chunkId] + ".js";
};